module.exports = __webpack_public_path__ + "static/media/phone.79b740b2.svg";